'use client';

import { MantineProvider, createTheme } from '@mantine/core';
import { ModalsProvider } from "@mantine/modals";

const theme = createTheme({
  defaultRadius: "0.5rem",
});

interface ProvidersProps {
  children: React.ReactNode;
}

export default function Providers({ children }: ProvidersProps) {
  return (
    <MantineProvider theme={theme}>
      <ModalsProvider>
        {children}
      </ModalsProvider>
    </MantineProvider>
  );
} 